import React from "react";
import { Box, Switch, Typography, useTheme } from "@mui/material";

type Props = {
    label: string;
    helper?: string;
    checked: boolean;
    disabled?: boolean;
    onChange: (checked: boolean) => void;
};

/** Linha com rótulo + texto auxiliar opcional + Switch. */
const ToggleRow: React.FC<Props> = ({ label, helper, checked, disabled, onChange }) => {
    const theme = useTheme();
    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                py: "14px",
                borderBottom: `1px solid ${theme.palette.divider}`,
                gap: 2,
            }}
        >
            <Box sx={{ flex: 1 }}>
                <Typography sx={{ fontSize: 14, fontWeight: 500, color: "text.primary", lineHeight: 1.3 }}>{label}</Typography>
                {helper && <Typography sx={{ fontSize: 12, color: "text.secondary", mt: "2px" }}>{helper}</Typography>}
            </Box>
            <Switch
                checked={checked}
                disabled={disabled}
                onChange={(e) => onChange(e.target.checked)}
                sx={{
                    "& .MuiSwitch-track": {
                        backgroundColor: checked ? undefined : theme.palette.brand.toggleOff,
                        opacity: checked ? undefined : 1,
                    },
                }}
            />
        </Box>
    );
};

export default ToggleRow;
